import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { aboutUs } from "../services/aboutUsService";

export const fetchAboutUs = createAsyncThunk(
    "about/fetch",
    async (_, { rejectWithValue }) => {
        try {
            return await aboutUs();
        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
);

const aboutSlice = createSlice({
    name: "about",
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {
        resetAbout: () => ({
            data: null,
            loading: false,
            error: null,
        }),
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAboutUs.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAboutUs.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchAboutUs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { resetAbout } = aboutSlice.actions;
export default aboutSlice.reducer;
